<template>
  <div class="last-card">
    <div class="last-card__background" />
    <div class="last-card__wrapper">
      <div class="last-card__left">
        <span class="last-card__logo"></span>
        <slot name="title" v-bind:inputData="inputData.title">
          <h1 class="last-card__title" v-text="inputData.title" />
        </slot>
        <slot name="subtitle" v-bind:inputData="inputData.subTitle">
          <div class="items-wrapper">
            <h2 class="last-card__sub-title" v-text="inputData.subTitle" />
            <div class="last-card__google-maps" />
          </div>
        </slot>
        <slot name="paragraphHead" v-bind:inputData="inputData.paragraphHead">
          <h2
            class="last-card__sub-title last-card__paragraph-head"
            v-html="inputData.paragraphHead"
          />
        </slot>
        <slot name="paragraph" v-bind:inputData="inputData.paragraph">
          <h2
            class="last-card__sub-title last-card__paragraph"
            v-html="inputData.paragraph"
          />
        </slot>
        <div class="last-card__social-icons" v-show="inputData.social">
          <slot name="social" v-bind:inputData="inputData.social">
            <a
              v-for="(value, key) in inputData.social"
              :key="key"
              :href="value.href"
              target="_blank"
            >
              <i class="icon" :class="value.class"></i>
            </a>
          </slot>
        </div>
      </div>
      <div class="last-card__right">
        <slot name="navigation" v-bind:navigationPages="navigationPages">
          <ul class="navigation-bottom">
            <li
              v-for="(value, key) in navigationPages"
              :key="key"
              class="navigation__item"
            >
              <a :href="value.href">
                <span v-text="value.name" />
              </a>
            </li>
          </ul>
        </slot>
        <div class="logos-wrapper">
          <span class="logo">
            <i :class="'ion-ios-people'" />
          </span>
          <span class="logo">
            <i :class="'ion-ios-color-wand'" />
          </span>
          <span class="logo">
            <i :class="'ion-ios-rocket'" />
          </span>
        </div>
        <span class="form-header"
          >Keep up to date with the latest news from Akrinum</span
        >
        <div class="flexi-form">
          <slot name="form">
            <form
              v-if="!loadingForm"
              @submit.prevent="handleClick"
              id="news-form"
              novalidate
              data-vv-scope="news-form"
            >
              <div class="flexi-wrapper">
                <div class="input--item">
                  <input
                    v-model="newsForm.firstName"
                    v-validate="{ required: true, min: 1 }"
                    name="First-name"
                    placeholder="First Name"
                    autocomplete="off"
                    @paste.prevent
                    :class="{
                      'valid-input': errors.has('news-form.First-name')
                    }"
                    required
                  />
                  <validation-message
                    :message="errors.first('news-form.First-name')"
                    :show="errors.has('news-form.First-name')"
                  />
                </div>
                <div class="input--item">
                  <input
                    v-model="newsForm.lastName"
                    v-validate="{ required: true, min: 1 }"
                    name="Last-name"
                    type="text"
                    placeholder="Last Name"
                    autocomplete="off"
                    :class="{
                      'valid-input': errors.has('news-form.Last-name')
                    }"
                    @paste.prevent
                    required
                  />
                  <validation-message
                    :message="errors.first('news-form.Last-name')"
                    :show="errors.has('news-form.Last-name')"
                  />
                </div>
              </div>
              <div class="flexi-wrapper-email">
                <input
                  v-lowercase
                  v-model="newsForm.email"
                  v-validate="{ required: true, email: true }"
                  name="Email"
                  type="email"
                  placeholder="Email"
                  autocomplete="off"
                  :class="{ 'valid-input': errors.has('news-form.Email') }"
                  @paste.prevent
                  required
                />
                <validation-message
                  :message="errors.first('news-form.Email')"
                  :show="errors.has('news-form.Email')"
                />
              </div>
              <div class="btn-wrapper space-between">
                <flexi-button :text="inputData.buttonText" />
              </div>
            </form>
            <hollow-dots-spinner
              class="spinner__bottom"
              v-else
              :animation-duration="spinnerOptions.animationDuration"
              :dot-size="spinnerOptions.dotSize"
              :dots-num="spinnerOptions.dotsNum"
              :color="spinnerOptions.color"
            />
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "flexi-advanced-last-card",
  props: {
    inputData: {
      type: Object
    },
    navigationPages: {
      type: Array
    },
    loadingForm: {
      type: Boolean
    },
    spinnerOptions: {
      type: Object,
      default: () => {
        return {
          animationDuration: 1000,
          dotSize: 15,
          dotsNum: 3,
          color: "#12C1FF"
        };
      }
    }
  },
  data() {
    return {
      newsForm: {
        firstName: null,
        lastName: null,
        email: null
      }
    };
  },
  methods: {
    handleClick() {
      this.$validator.validateAll("news-form").then(result => {
        if (result) {
          this.$emit("button-clicked", this.newsForm);
        }
      });
    }
  }
};
</script>
